<script lang="ts" setup>
import { inject } from 'vue'
import type { Router } from 'vue-router'

defineProps({
  base: {
    type: String,
    required: false,
  },
  label: String,
  route: String,
  icon: {
    type: String,
    required: false,
  },
  isVisible: {
    type: Boolean,
    default: true,
    required: false,
  },
  force: {
    type: Boolean,
    default: false,
    required: false,
  },
  params: {
    type: String,
    default: undefined,
    required: false,
  },
})

const router: Router | undefined = inject('default-router')
const baseURL =  !__props.base || __props.base === '/' ? '' : __props.base.substring(0, __props.base.lastIndexOf('/'))

const activeRoute = computed(() => {
  if (!router || !router.isReady)
    return
  // console.log(router.currentRoute.value.matched, router.currentRoute.value)
  const matchedRoutes = router.currentRoute.value.matched
  // console.log(matchedRoutes)
  const lastRoute = matchedRoutes[matchedRoutes.length - 1]
  // console.log(lastRoute)
  return lastRoute && lastRoute.name ? lastRoute.name : ''
})
const targetRoute = computed(() => {
  if (!router || !router.isReady)
    return
  return router.resolve({ name: __props.route })
})

function forceNavigation() {
  // (window as any).navigation.navigate(targetRoute.value ? targetRoute.value.fullPath : '/')
  window.location.href = targetRoute.value
    ? __props.params ? baseURL + targetRoute.value.fullPath + '?' + __props.params : baseURL + targetRoute.value.fullPath
    : `${baseURL}/`
}
</script>

<template>
  <router-link
    v-if="isVisible"
    class="group flex items-center rounded-lg p-2 text-base text-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
    :class="activeRoute === route ? 'bg-gray-200 dark:bg-gray-700' : ''"
    :to="targetRoute ? { path: targetRoute.fullPath } : { path: '/' }"
    custom
    v-slot="{ href, navigate }"
  >
    <a
      v-if="force"
      class="group flex cursor-pointer items-center rounded-lg p-2 text-base text-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
      :class="activeRoute === route ? 'bg-gray-200 dark:bg-gray-700' : ''"
      @click="forceNavigation"
    >
      <div
        :i="icon"
        class="h-6 w-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      />
      <span class="ml-3" sidebar-toggle-item>{{ label }}</span>
    </a>
    <a
      v-else
      class="group flex cursor-pointer items-center rounded-lg p-2 text-base text-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
      :class="activeRoute === route ? 'bg-gray-200 dark:bg-gray-700' : ''"
      :href="href"
      @click="navigate"
    >
      <div
        :i="icon"
        class="h-6 w-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      />
      <span class="ml-3" sidebar-toggle-item>{{ label }}</span>
    </a>
  </router-link>
</template>
